import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import classes from './stoniTenis.module.css'
import { useEffect, useState } from 'react'

const StoniTenis = ({ calculatorType = 'Stoni tenis' }) => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', ''],
      sets: [''],
      setsBoth: ['', '', '', '', '', ''],
    },
    results: {
      oddsPercentages: ['', ''],
      sets: ['', '', '', ''],
      score: ['', ''],
      teamStrengths: ['', '', '', '', '', '', '', ''],
    },
  })

  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const clearFields = () => {
    setData({
      values: {
        odds: ['', ''],
        sets: [''],
        setsBoth: ['', '', '', '', '', ''],
      },
      results: {
        oddsPercentages: ['', ''],
        sets: ['', '', '', ''],
        score: ['', ''],
        teamStrengths: ['', '', '', '', '', '', '', ''],
      },
    })
    setShowInputArea(true)
  }

  const calculateTenisStats = () => {
    const odds = data?.values?.odds || ['', '']
    const sets = data?.values?.sets || ['']
    const setsBoth = data?.values?.setsBoth || ['', '', '', '', '', '']

    const [odd1Str, odd2Str] = odds
    const [setsToWinStr] = sets
    const [wins1Str, losses1Str, played1Str, wins2Str, losses2Str, played2Str] =
      setsBoth

    const percentage1 = 1 / odd1Str
    const percentage2 = 1 / odd2Str
    let totalPercentage = percentage1 + percentage2

    totalPercentage = totalPercentage * 100

    const over100Percentage = totalPercentage - 100

    const halfOfOverage = over100Percentage / 2

    let b58 = odd1Str

    let m59 = b58

    let o59 = (1 / m59) * 100

    let c58 = odd2Str

    let n59 = c58

    let p59 = (1 / n59) * 100

    let q59 = o59 + p59

    let r59 = q59 - 100

    let s59 = r59 / 2

    let winChancePlayer1 = parseFloat(o59 - s59).toFixed(2)
    let winChancePlayer2 = (percentage2 * 100 - halfOfOverage).toFixed(2)

    let maxSets = Math.round(
      Math.floor(parseFloat(setsToWinStr) - 1 + parseFloat(setsToWinStr))
    )
    const minSets = Math.floor(setsToWinStr)
    const midSets = Math.floor((minSets + maxSets) / 2)

    // Average sets won/lost per match for Player 1
    let avgSetsWonP1 = wins1Str / played1Str

    let avgSetsLostP1 = losses1Str / played1Str

    // Average sets won/lost per match for Player 2
    let avgSetsWonP2 = wins2Str / played2Str

    let avgSetsLostP2 = losses2Str / played2Str

    let avgTotalP1 = avgSetsWonP1 + avgSetsLostP1
    let avgTotalP2 = avgSetsWonP2 + avgSetsLostP2

    let halfMaxSets = maxSets / 2
    let avgTotalSetsBoth = (avgTotalP1 + avgTotalP2) / 2

    let setsPerMatch = parseFloat(setsToWinStr)
    let targetThreshold = setsPerMatch * 2 - 1

    let adjustedAvgSets
    if (avgTotalSetsBoth > targetThreshold) {
      adjustedAvgSets = (setsPerMatch + targetThreshold) / 2
    } else {
      adjustedAvgSets = avgTotalSetsBoth
    }

    let expectedSetsPlayer1 = Math.round(
      parseFloat(winChancePlayer1 / 100) * adjustedAvgSets
    )
    let expectedSetsPlayer2Float =
      (parseFloat(winChancePlayer2) / 100) * adjustedAvgSets

    let finalSetsPlayer1
    if (winChancePlayer1 >= winChancePlayer2) {
      finalSetsPlayer1 = Math.round(halfMaxSets)
    } else {
      finalSetsPlayer1 = expectedSetsPlayer1
    }

    let finalSetsPlayer2
    if (finalSetsPlayer1 === Math.round(halfMaxSets)) {
      finalSetsPlayer2 = expectedSetsPlayer2Float
    } else {
      finalSetsPlayer2 = halfMaxSets
    }

    let totalFinalSets = finalSetsPlayer1 + finalSetsPlayer2

    let setsPlayer1
    if (totalFinalSets >= maxSets && percentage1 >= percentage2) {
      setsPlayer1 = Math.round(halfMaxSets)
    } else {
      setsPlayer1 = finalSetsPlayer1
    }

    let setsPlayer2
    if (totalFinalSets >= maxSets && percentage1 < percentage2) {
      setsPlayer2 = Math.round(halfMaxSets)
    } else {
      setsPlayer2 = Math.round(finalSetsPlayer2)
    }

    let totalBalance = setsPlayer1 + setsPlayer2

    let suggestedBetValue =
      Math.round(parseFloat(setsToWinStr) + totalBalance) / 2 - 0.5
    let suggestedBetString = `${parseFloat(suggestedBetValue).toFixed(1)} +`

    // Averages for stats
    let avgSODG = (avgSetsLostP1 + avgSetsWonP2) / 2
    let avgSNDG = (avgSetsWonP1 + avgSetsLostP2) / 2

    let avgSNDSOG = (avgSetsWonP1 + avgSetsWonP2) / 2

    let avgSODSNG = (avgSetsLostP1 + avgSetsLostP2) / 2

    setData((prev) => ({
      ...prev,
      results: {
        oddsPercentages: [winChancePlayer1, winChancePlayer2],
        sets: [minSets, midSets, maxSets, suggestedBetString],
        score: [setsPlayer1, setsPlayer2],
        teamStrengths: [
          avgSetsWonP1.toFixed(2), // SND
          avgSetsLostP1.toFixed(2), // SOD
          avgSetsLostP2.toFixed(2), // SNG
          avgSetsWonP2.toFixed(2), // SOG
          avgSNDG.toFixed(2), // SNDG
          avgSODG.toFixed(2), // SODG
          avgSNDSOG.toFixed(2), // SNDSOG
          avgSODSNG.toFixed(2),
        ],
      },
    }))
  }

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    } else {
      calculateTenisStats()
    }
    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  console.log('data', data)

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod meča
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'odds'}
                labelPrefix={['KI 1', 'KI 2']}
                step={['0.1', '0.1']}
                min={['0.1', '0.1']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
                calculation={calculateTenisStats}
              />
              <div className={classesK.sectionTitle}>
                Meč na broj dobijenih setova
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'sets'}
                labelPrefix={['Br. dobijenih setova na koliko se igra meč']}
                step={['1']}
                min={['1']}
                type={['number']}
                setError={setError}
                rows={1}
                calculation={calculateTenisStats}
              />
              <div className={classesK.sectionTitle}>
                Upiši br. Setova / br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'setsBoth'}
                labelPrefix={[
                  'TIM / IGRAČ 1 +  (pobedio setova)',
                  'TIM / IGRAČ 1 - (izgubio setova)',
                  'TIM / IGRAČ 1 (odigrao br. mečeva)',
                  'TIM / IGRAČ 2 +  (pobedio setova)',
                  'TIM / IGRAČ 2-  (izgubio setova)',
                  'TIM / IGRAČ 2 (odigrao br. mečeva)',
                ]}
                step={['1', '1', '1', '1', '1', '1']}
                min={['1', '1', '1', '1', '1', '1']}
                type={[
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                setError={setError}
                rows={3}
                calculation={calculateTenisStats}
              />
            </div>
          </>
        )}

        {!showInputArea && (
          <div className={classes.sectionResults}>
            <ResultsSection
              title={'Ishod meča'}
              subtitle={'Konačan ishod'}
              results={data?.results?.oddsPercentages.map(
                (result) => `${result}%`
              )}
              names={['KI 1', 'KI 2']}
              withPercent={true}
            />
            <ResultsSection
              title={'Setovi'}
              subtitle={'Predikcije setova'}
              results={data?.results?.sets}
              names={[
                'Predikcija minimalnog br. setova na meču',
                'Predikcija srednjeg br. setova na meču',
                'Predikcija maksimalnog broja setova na meču',
                'Betko predlog za broj setova na meču ( + )',
              ]}
              rows={2}
            />
            <ResultsSection
              title={'Tačan rezultat u setovima'}
              subtitle={'Predikcije osvojenih setova'}
              results={data?.results?.score}
              names={[
                'Očekivani broj osvojenih setova Tim/Igrač 1',
                'Očekivani broj osvojenih setova Tim/Igrač 2',
              ]}
            />
            <ResultsSection
              title={'Snage timova'}
              subtitle={'Snaga domaćina'}
              results={[
                data?.results?.teamStrengths[0],
                data.results?.teamStrengths[1],
              ]}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snaga gosta'}
              results={[
                data?.results?.teamStrengths[2],
                data.results?.teamStrengths[3],
              ]}
              names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snage oba tima zajedno'}
              results={[
                data?.results?.teamStrengths[4],
                data.results?.teamStrengths[5],
              ]}
              names={[
                'SNDG ( snaga napada domaćina i gosta )',
                'SODG ( snaga odbrane domaćina i gosta )',
              ]}
            />
            <ResultsSection
              subtitle={'Tim proseci odbrana i napada'}
              results={[
                data?.results?.teamStrengths[6],
                data.results?.teamStrengths[7],
              ]}
              names={[
                'SND+SOG ( snaga napada domaćin + snaga odbrane gost )',
                'SOD+SNG ( snaga napada domaćin + snaga odbrane gost )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default StoniTenis
